/**
 * Snowflake IDs: 64-bit, time-sortable identifiers serialized as decimal strings.
 * Layout: 42 bits ms since EPOCH | 10 bits worker | 12 bits sequence.
 */
export const SNOWFLAKE_EPOCH = 1767225600000n; // 2026-01-01T00:00:00Z
export class SnowflakeGenerator {
    sequence = 0n;
    lastTimestamp = -1n;
    worker;
    constructor(workerId = 0) {
        if (workerId < 0 || workerId > 1023)
            throw new RangeError('workerId must be 0-1023');
        this.worker = BigInt(workerId);
    }
    next(now = Date.now()) {
        let ts = BigInt(now) - SNOWFLAKE_EPOCH;
        if (ts < this.lastTimestamp)
            ts = this.lastTimestamp; // clock went backwards; stay monotonic
        if (ts === this.lastTimestamp) {
            this.sequence = (this.sequence + 1n) & 0xfffn;
            if (this.sequence === 0n)
                ts = this.lastTimestamp + 1n; // sequence exhausted; borrow next ms
        }
        else {
            this.sequence = 0n;
        }
        this.lastTimestamp = ts;
        return ((ts << 22n) | (this.worker << 12n) | this.sequence).toString();
    }
}
export function snowflakeTimestamp(id) {
    return Number((BigInt(id) >> 22n) + SNOWFLAKE_EPOCH);
}
/** Smallest snowflake that could have been generated at `time` (useful for range queries). */
export function snowflakeFromTime(time) {
    return ((BigInt(time) - SNOWFLAKE_EPOCH) << 22n).toString();
}
export function compareSnowflakes(a, b) {
    const x = BigInt(a);
    const y = BigInt(b);
    return x < y ? -1 : x > y ? 1 : 0;
}
export const isSnowflake = (v) => /^\d{1,20}$/.test(v);
//# sourceMappingURL=snowflake.js.map